/**
 * Shared result shape for every data-access call in core.
 *
 * Callers get `{ data, error }` instead of exceptions (the pattern the app
 * has used since the RN version). Implementations stay exception-based and
 * wrap themselves in `toResult`, so the try/catch → DbResult translation
 * lives in exactly one place.
 */

export interface DbResult<T> {
  data: T | null;
  error: Error | null;
}

export function toError(e: unknown): Error {
  return e instanceof Error ? e : new Error(String(e));
}

/** Run `fn`, returning its value as `data` or anything it throws as `error`. */
export async function toResult<T>(fn: () => Promise<T>): Promise<DbResult<T>> {
  try {
    return { data: await fn(), error: null };
  } catch (e: unknown) {
    return { data: null, error: toError(e) };
  }
}
